<template>
    <div class="cabinet__catalog-item">
        <div v-if="!list" class="cabinet__catalog-favorite">
            <div class="cabinet-favorite-checkbox">
                <input
                    type="checkbox"
                    :checked="isFavourite"
                    @click.prevent="onClickFavourite"
                />
                <span class="cabinet-favorite-checkbox__checkmark"></span>
            </div>
            <div
                v-if="isListOpened"
                v-click-outside="closeLists"
                class="cabinet__catalog-favorite_list"
            >
                <div
                    v-for="list of lists(productLists)"
                    :key="list.ListID"
                    class="cabinet__catalog-favorite_list-item"
                >
                    <label class="app-checkbox">
                        <input
                            type="checkbox"
                            :value="list.ListID"
                            :checked="list.checked"
                            @click.prevent="
                                onClickList(list.ListID, list.checked)
                            "
                        />
                        <span class="app-checkbox__checkmark"></span>
                        {{ list.ListName }}
                    </label>
                </div>
                <div
                    class="cabinet__catalog-favorite_list-item d-flex align-items-center"
                >
                    <label
                        class="app-checkbox"
                        :class="{ disabled: !newListName }"
                    >
                        <input
                            type="checkbox"
                            :disabled="!newListName"
                            @change="addNewList(newListName)"
                        />
                        <span class="app-checkbox__checkmark"></span>
                    </label>
                    <input
                        v-model="newListName"
                        type="text"
                        class="cabinet-form-group__input"
                        placeholder="Создать новый"
                        @keypress.enter="addNewList(newListName)"
                    />
                </div>
            </div>
        </div>

        <div
            v-if="list"
            class="cabinet__catalog-remove"
            title="Удалить изделие из списка"
            @click="removeItemFromList"
        />

        <router-link
            :to="`/catalog/product/${product.ItemID}`"
            class="cabinet__catalog-image"
        >
            <img :src="product.images.length ? product.images[0].url : null" />
        </router-link>
        <div class="cabinet__catalog-top">
            <div class="cabinet__catalog-title d-flex align-items-center">
                <a
                    v-if="product.brand.subdomain_url"
                    :href="product.brand.subdomain_url"
                    class="cabinet__catalog-title_value"
                >
                    {{ product.brand ? product.brand.BrandName : '—' }}
                </a>
                <router-link
                    v-else
                    :to="`/account/brands/${product.brand.BrandID}`"
                    class="cabinet__catalog-title_value"
                >
                    {{ product.brand ? product.brand.BrandName : '—' }}
                </router-link>
                <i
                    v-if="showAccess && product.brand.has_restricted_items"
                    class="cabinet__catalog-lock"
                    :class="{
                        'icon-unlock':
                            product.brand.approved_access_to_restricted_items
                    }"
                >
                    <div class="cabinet__catalog-tooltip">
                        <div class="cabinet__catalog-tooltip_text">
                            {{
                                product.brand
                                    .approved_access_to_restricted_items
                                    ? 'Вам открыт доступ к скрытым изделиям этого бренда'
                                    : 'У бренда есть скрытые изделия'
                            }}
                        </div>
                        <div class="cabinet__catalog-tooltip_link">
                            <a
                                v-if="
                                    product.brand.access_status === null ||
                                        product.brand.access_status ===
                                            'forbidden'
                                "
                                href="javascript:void(0)"
                                @click.prevent="
                                    $emit(
                                        'openRequestAccessModal',
                                        product.brand
                                    )
                                "
                            >
                                Запросить доступ
                            </a>
                            <span
                                v-if="product.brand.access_status === 'new'"
                                class="color-gray"
                            >
                                Запрос доступа отправлен
                            </span>
                        </div>
                    </div>
                </i>
            </div>
            <div class="cabinet__catalog-category truncate">
                {{ getTypeNameByID(product.TypeID) }}
            </div>
            <div class="cabinet__catalog-code truncate">
                {{
                    product.Article
                        ? `Арт. ${product.Article}`
                        : product.sets.length
                        ? ''
                        : '&nbsp;'
                }}
                <v-tooltip
                    v-if="product.sets.length"
                    class="cursor-default"
                    :class="{ 'ml-2': product.Article }"
                    title="Артикул гарнитура"
                >
                    [{{ product.sets[0].set_article }}]
                </v-tooltip>
            </div>
        </div>
        <div class="cabinet__catalog-tags d-flex flex-wrap subtitle2">
            <template v-for="material of product.materials">
                <div
                    :key="material.MaterialID"
                    class="cabinet__catalog-tag"
                    :class="{ hidden: material.MaterialID == 13 }"
                >
                    <a>{{ material.Name }}</a>
                </div>
                <div
                    v-if="material.pivot && material.pivot.Fineness"
                    :key="material.pivot.ItemID"
                    class="cabinet__catalog-tag"
                >
                    <a href="javascript:void(0)">
                        {{ material.pivot.Fineness }}
                    </a>
                </div>
            </template>
        </div>
        <div class="cabinet__catalog-info">
            <template v-if="product.price_expired == false">
                <div v-if="product.Price > 0" class="cabinet__catalog-price">
                    {{ getFormattedNum(product.Price || 0) }} ₽{{ priceUnit }}
                </div>
            </template>
            <div
                v-if="parseFloat(product.Weight) > 0 && !isWatchCategory"
                class="cabinet__catalog-weight"
            >
                {{ product.Weight }} гр
            </div>
        </div>
        <div
            v-if="isInCart"
            class="cabinet__catalog-form d-flex align-items-center w-100"
        >
            <button
                class="cabinet__catalog-form_minus"
                @click="decreaseQuantityInCart"
            />
            <input
                type="text"
                class="cabinet__catalog-form_input cabinet-form-group__input"
                :value="inCartQuantity"
                @change="onInCartQuantityInput"
            />
            <button
                class="cabinet__catalog-form_plus"
                @click="increaseQuantityInCart"
            />
            <button
                v-if="false"
                type="button"
                class="cabinet__catalog-form_remove ml-auto"
                title="Удалить из корзины"
                @click="removeProductFromCart"
            />
        </div>
        <button
            v-else
            class="cabinet-btn cabinet__catalog-button"
            @click="addProductToCart"
        >
            В корзину
        </button>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import { mapActions, mapState, mapGetters } from 'vuex'
import getNameById from '@/mixins/getNameById'
import checkDemoUser from '@/mixins/checkDemoUser.js'
import getFormattedNum from '@/utils/getFormattedNum'

export default {
    name: 'RetailerCatalogItem',
    directives: {
        clickOutside: vClickOutside.directive
    },
    mixins: [getNameById, checkDemoUser],
    props: {
        product: {
            type: Object,
            default: () => {}
        },
        list: {
            type: Number,
            default: undefined
        },
        showAccess: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            quantityTimer: null,
            isListOpened: false,
            productLists: this.product.save_lists,
            isInCart: this.product.is_in_cart,
            newListName: '',
            favouriteLoader: false,
            cartLoader: false,
            inCartQuantity: 0
        }
    },
    computed: {
        ...mapState('supplierCollections', ['collections']),
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('types', { types: 'supplierTypes' }),
        ...mapGetters('retailerLists', { lists: 'productListsForCheck' }),
        productInCart() {
            return this.$store.getters['cart/productInCart'](this.productID)
        },
        isFavourite() {
            return !!this.productLists.length
        },
        productID() {
            return this.product.ItemID
        },
        priceUnit() {
            const unit = this.getNameById(
                this.priceUnitOptions,
                'abbr',
                'id',
                this.product.PriceUnit
            )

            return unit ? `/${unit}` : ''
        },
        isWatchCategory() {
            return this.product.CategoryID === 5 //Часы
        }
    },
    created() {
        this.inCartQuantity = this.productInCart
            ? this.productInCart.pivot.Quantity
            : 0
    },
    methods: {
        ...mapActions('retailerLists', ['getLists', 'removeItem']),
        ...mapActions('cart', [
            'getCart',
            'addToCart',
            'deleteFromCart',
            'changeItemQuantity'
        ]),
        getFormattedNum,
        getTypeNameByID(id) {
            return this.types.length
                ? this.types.filter(type => type.TypeID === parseInt(id, 10))[0]
                      .Name || '—'
                : '—'
        },
        clearNewListName() {
            this.newListName = ''
        },
        closeLists() {
            this.isListOpened = false
            this.clearNewListName()
        },
        openLists() {
            this.isListOpened = true
        },
        getProductLists() {
            return this.$axios
                .get(`/retailer/items/${this.productID}?notrack=1`)
                .then(({ data }) => {
                    this.productLists = data.save_lists
                })
        },
        onClickFavourite() {
            if (this.isDemoUserMode()) return

            if (!this.isFavourite) {
                this.addToDefaultList()
                    .then(() => {
                        this.getProductLists()
                    })
                    .then(() => {
                        this.openLists()
                    })
            } else {
                this.openLists()
            }
        },
        addToDefaultList() {
            return this.$axios.post(
                `/retailer/items/${this.productID}/default-list`
            )
        },
        addToList(listID) {
            return this.$axios.post(
                `/retailer/items/${this.productID}/list/${listID}`
            )
        },
        removeFromList(listID) {
            return this.$axios.delete(
                `/retailer/items/${this.productID}/list/${listID}`
            )
        },
        addNewList(listName) {
            this.$axios
                .post('/retailer/lists', {
                    ListName: listName
                })
                .then(({ data }) => {
                    const newListID = data.ListID

                    this.clearNewListName()
                    this.addToList(newListID)
                        .then(() => {
                            this.getProductLists()
                        })
                        .then(() => {
                            this.getLists()
                        })
                })
        },
        onClickList(listID, isChecked) {
            const query = []

            if (isChecked) {
                query.push(this.removeFromList(listID))
            } else {
                query.push(this.addToList(listID))
            }

            Promise.all(query).then(() => {
                this.getProductLists()
            })
        },
        addProductToCart() {
            if (this.isDemoUserMode()) return

            this.cartLoader = true

            this.addToCart(this.productID)
                .then(() => {
                    this.getCart()
                    this.isInCart = true
                    this.inCartQuantity = 1

                    this.$notify({
                        type: 'success',
                        title: 'Изделие добавлено в корзину'
                    })
                })
                .finally(() => {
                    this.cartLoader = false
                })
        },
        removeProductFromCart() {
            this.cartLoader = true

            this.deleteFromCart(this.productID)
                .then(() => {
                    this.getCart()
                    this.isInCart = false
                    this.inCartQuantity = 0

                    this.$notify({
                        type: 'default',
                        title: 'Изделие удалено из корзины'
                    })
                })
                .finally(() => {
                    this.cartLoader = false
                })
        },
        increaseQuantityInCart() {
            this.inCartQuantity++
            this.changeQuantityInCart()
        },
        decreaseQuantityInCart() {
            if (this.inCartQuantity > 1) {
                this.inCartQuantity--
                this.changeQuantityInCart()
            } else {
                this.removeProductFromCart()
            }
        },
        onInCartQuantityInput(e) {
            let val = e.target.value
            this.inCartQuantity = parseInt(val.replace(/\D/g, '') || 0)
            e.target.value = this.inCartQuantity
            if (this.inCartQuantity >= 1) {
                this.changeQuantityInCart()
            } else {
                this.removeProductFromCart()
            }
        },
        changeQuantityInCart() {
            if (this.quantityTimer) {
                clearInterval(this.quantityTimer)
            }

            this.quantityTimer = setTimeout(() => {
                this.changeItemQuantity({
                    productID: this.productID,
                    quantity: this.inCartQuantity,
                    comment: this.productInCart.pivot.Comment
                })
            }, 1000)
        },
        removeItemFromList() {
            this.$Progress.start()

            this.removeItem({
                listID: this.list,
                itemID: this.productID
            })
                .then(() => {
                    this.$emit('removedFromList')
                    this.$notify({
                        type: 'default',
                        title: 'Изделие удалено из списка'
                    })
                })
                .finally(() => {
                    this.$Progress.finish()
                })
        }
    }
}
</script>
